import { BasicParallelEnumerable } from "../BasicParallelEnumerable.js";
export const zipAsync = (first, second, resultSelector) => {
    const generator = async () => {
        const [left, right] = await Promise.all([first.toArray(), second.toArray()]);
        const minLength = left.length < right.length ? left.length : right.length;
        const resultPromises = new Array(minLength);
        for (let i = 0; i < minLength; i++) {
            const a = left[i];
            const b = right[i];
            resultPromises[i] = resultSelector(a, b);
        }
        return Promise.all(resultPromises);
    };
    return new BasicParallelEnumerable({
        generator,
        type: 0,
    });
};
